//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomTable from "@/components/FilterTable/Table.vue";
import moment from "moment";

export default {
  name: "UploadsTable",
  props: [
    "tableClass",
    "bordered",
    "recordsTotal",
    "data",
    "typeName",
    "isLoading",
  ],
  components: {
    CustomTable,
  },
  data: function () {
    return {
      separator: "horizontal",
      pagination: {
        rowsPerPage: 30,
      },
      columns: [
        {
          name: "id",
          required: true,
          label: "#ID",
          align: "left",
          field: (row) => row.id,
        },
        {
          name: "name",
          align: "left",
          label: "Nome do ficheiro",
          field: (row) => row.filename,
        },
        {
          name: "type",
          align: "left",
          label: "Tipo de ficheiro",
          field: (row) => row.file_upload_mapping.name,
        },
        {
          name: "reference-date",
          align: "left",
          label: "Data de referência",
          field: (row) => row.reference_date,
        },
        {
          name: "upload-date",
          align: "left",
          label: "Data de carregamento",
          field: (row) => moment(row.created_at).format("yyyy-MM-DD"),
        },
        {
          name: "store-level",
          align: "left",
          label: "Nível de Loja",
          field: (row) =>
            row.file_upload_mapping.store_level
              ? row.file_upload_mapping.store_level.name
              : "N/A",
          hide: this.typeName !== "Retalhista",
        },
        {
          name: "store-level-element",
          align: "left",
          label: "Nome de Nível de Loja",
          field: (row) =>
            row.file_upload_mapping.store_level_element
              ? row.file_upload_mapping.store_level_element.name
              : "N/A",
          hide: this.typeName !== "Retalhista",
        },
        //field "N/A" if row.user.name null
        {
          name: "user",
          align: "left",
          label: "Utilizador",
          field: (row) => (row.user ? row.user.name : "N/A"),
        },
        {
          name: "duration",
          align: "left",
          label: "Duração",
          field: (row) => {
            if (row.duration == null) {
              return row.duration;
            }
            let result = [];
            let minutes = Math.floor(row.duration / 60);
            let seconds = row.duration - minutes * 60;
            if (minutes) {
              result.push(`${minutes} minutos`);
            }
            if (seconds) {
              result.push(`${seconds} segundos`);
            }
            return result.join(" e ");
          },
        },
        {
          name: "state",
          align: "left",
          label: "Estado",
          field: (row) => row.status,
          icon: {
            conditional: true,
            created: {
              name: "mdi-alert-circle-outline",
              label: "Pendente",
              color: "yellow-4",
            },
            started: {
              name: "mdi-cached",
              label: "Iniciado",
              color: "blue-5",
            },
            successful: {
              name: "mdi-check-circle-outline",
              label: "Válido",
              color: "green-4",
            },
            warning: {
              name: "mdi-help-circle-outline",
              label: "Elementos sem validação",
              color: "purple-4",
            },
            failure: {
              name: "mdi-close-circle-outline",
              label: "Inválido",
              color: "red-4",
            },
            rolled_back: {
              name: "fast_rewind",
              label: "Sellout Eliminado",
              color: "red-4",
            },
          },
        },
      ],
    };
  },
  methods: {
    emitLine(event) {
      this.$emit("clicked-row", event);
    },
    updateSearch(search) {
      this.$emit("search-changed", search);
    },
    deleteFileUpload(event) {
      this.$emit("delete-sellout", event);
    }
  },
};
